import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Database, CalendarClock, Phone, Headphones, UserPlus, Globe2, Palette, Megaphone, Share2 } from 'lucide-react';
import SectionLabel from './SectionLabel';
import Reveal from './Reveal';
import { useI18n } from '../i18n/I18nContext';

const ICONS = [Database, CalendarClock, Phone, Headphones, UserPlus, Globe2, Palette, Megaphone, Share2];

export default function ServicesGrid() {
  const { t } = useI18n();
  const cards = t('services_grid.cards') || [];
  return (
    <section className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7 space-y-5">
            <SectionLabel>{t('services_grid.tag')}</SectionLabel>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold text-slate-900 leading-[1.05]">
              {t('services_grid.title_a')} <span className="text-gradient-green">{t('services_grid.title_b')}</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-8">
            <p className="text-slate-700/60 text-base md:text-lg leading-relaxed">{t('services_grid.subtitle')}</p>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={s.title} delay={i * 40}>
                <Link to="/services" className="group relative block h-full rounded-2xl border border-blue-500/10 bg-white p-6 overflow-hidden hover:border-blue-500/35 card-lift">
                  <span className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-blue-500/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="relative flex items-start justify-between mb-14">
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-500/10 border border-blue-500/20 group-hover:bg-blue-500/20 group-hover:border-blue-500/40 transition-all">
                      <Icon className="h-5 w-5 text-blue-600" strokeWidth={1.7} />
                    </div>
                    <ArrowUpRight className="h-5 w-5 text-slate-400 group-hover:text-blue-600 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
                  </div>
                  <h3 className="relative font-display text-lg font-medium text-slate-900 mb-2">{s.title}</h3>
                  {s.tag && (
                    <div className="relative flex items-center gap-1.5 text-[11px] tracking-[0.18em] text-blue-600">
                      {s.tag.split(' · ').map((tt) => (
                        <span key={tt} className="rounded-md border border-blue-500/15 px-1.5 py-0.5">{tt}</span>
                      ))}
                    </div>
                  )}
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
